import data from './data/commitment'
let commitment = {
  data: data,
  "pinned": [
    "FundName",
  ],
  "width": {
    "FundName": 250,
    "Commitment_Date": 150
  },
  "immutable": {
    "FundName": true
  },
  "mapping": {
    "FundName": {
      "header": "Fund Name",
      "column": "FundName",
      "rules": null,
      "dataType": "currency",
      "meta": null,
      "placeholder": null,
      "validations": [],
      "type": null
    },
    "Currency": {
      "header": "Currency",
      "column": "Currency",
      "rules": null,
      "dataType": "currency",
      "meta": null,
      "placeholder": null,
      "validations": [],
      "order": true,
      "type": null
    },
    "Commitment_Date": {
      "header": "Commitment Date",
      "column": "Commitment_Date",
      "rules": null,
      "dataType": "currency",
      "meta": null,
      "placeholder": null,
      "validations": [],
      "type": null
    },
    "AACP_I_Commitment": {
      "header": "AACP I Commitment",
      "column": "AACP_I_Commitment",
      "rules": null,
      "sum": true,
      "dataType": "currency",
      "meta": null,
      "placeholder": null,
      "validations": [],
      "type": "commitment"
    },
    "Fund_I_Side_Car_Commitment": {
      "header": "Fund I Side Car Commitment",
      "column": "Fund_I_Side_Car_Commitment",
      "sum": true,
      "rules": null,
      "dataType": "currency",
      "meta": null,
      "placeholder": null,
      "validations": [],
      "type": "commitment"
    },
    "AACP_II_Commitment": {
      "sum": true,
      "header": "AACP II Commitment",
      "column": "AACP_II_Commitment",
      "rules": null,
      "dataType": "currency",
      "meta": null,
      "placeholder": null,
      "validations": [],
      "type": "commitment"
    },
    "Fund_II_Side_Car_Commitment": {
      "sum": true,
      "header": "Fund II Side Car Commitment",
      "column": "Fund_II_Side_Car_Commitment",
      "rules": null,
      "dataType": "currency",
      "meta": null,
      "placeholder": null,
      "validations": [],
      "type": "commitment"
    },
    "Ivory_Commitment": {
      "sum": true,
      "header": "Ivory Commitment",
      "column": "Ivory_Commitment",
      "rules": null,
      "dataType": "currency",
      "meta": null,
      "placeholder": null,
      "validations": [],
      "type": "commitment"
    },
    "NJAI_Commitment": {
      "sum": true,
      "header": "NJAI Commitment",
      "column": "NJAI_Commitment",
      "rules": null,
      "dataType": "currency",
      "meta": null,
      "placeholder": null,
      "validations": [],
      "type": "commitment"
    },
    "CAI_Commitments_Balanced": {
      "sum": true,
      "header": "CAI Commitments Balanced",
      "column": "CAI_Commitments_Balanced",
      "rules": null,
      "dataType": "currency",
      "meta": null,
      "placeholder": null,
      "validations": [],
      "type": "commitment"
    },
    "CAI_Commitments_Co_Investment": {
      "sum": true,
      "header": "CAI Commitments Co-Investment",
      "column": "CAI_Commitments_Co_Investment",
      "rules": null,
      "dataType": "currency",
      "meta": null,
      "placeholder": null,
      "validations": [],
      "type": "commitment"
    },
    "Fei__Commitment": {
      "sum": true,
      "header": "Fei  Commitment",
      "column": "Fei__Commitment",
      "rules": null,
      "dataType": "currency",
      "meta": null,
      "placeholder": null,
      "validations": [],
      "type": "commitment"
    },
    "AACP_III_Commitment": {
      "sum": true,
      "header": "AACP III Commitment",
      "column": "AACP_III_Commitment",
      "rules": null,
      "dataType": "currency",
      "meta": null,
      "placeholder": null,
      "validations": [],
      "type": "commitment"
    },
    "Fund_III_Side_Car_Commitment": {
      "sum": true,
      "header": "Fund III Side Car Commitment",
      "column": "Fund_III_Side_Car_Commitment",
      "rules": null,
      "dataType": "currency",
      "meta": null,
      "placeholder": null,
      "validations": [],
      "type": "commitment"
    },
    "NJAI_II_Commitment_Tranche_I": {
      "sum": true,
      "header": "NJAI II Commitment Tranche I",
      "column": "NJAI_II_Commitment_Tranche_I",
      "rules": null,
      "dataType": "currency",
      "meta": null,
      "placeholder": null,
      "validations": [],
      "type": "commitment"
    },
    "NJAI_II_Commitment_Tranche_II": {
      "sum": true,
      "header": "NJAI II Commitment Tranche II",
      "column": "NJAI_II_Commitment_Tranche_II",
      "rules": null,
      "dataType": "currency",
      "meta": null,
      "placeholder": null,
      "validations": [],
      "type": "commitment"
    },
    "Ivory_II_Commitment_Balanced": {
      "sum": true,
      "header": "Ivory II Commitment Balanced",
      "column": "Ivory_II_Commitment_Balanced",
      "rules": null,
      "dataType": "currency",
      "meta": null,
      "placeholder": null,
      "validations": [],
      "type": "commitment"
    },
    "Ivory_II_Commitment_Co_Investment": {
      "sum": true,
      "header": "Ivory II Commitment Co-Investment",
      "column": "Ivory_II_Commitment_Co_Investment",
      "rules": null,
      "dataType": "currency",
      "meta": null,
      "placeholder": null,
      "validations": [],
      "type": "commitment"
    },
    "MDAI_I_Commitment_Balanced": {
      "sum": true,
      "header": "MDAI I Commitment Balanced",
      "column": "MDAI_I_Commitment_Balanced",
      "rules": null,
      "dataType": "currency",
      "meta": null,
      "placeholder": null,
      "validations": [],
      "type": "commitment"
    },
    "MDAI_I_Commitment_Co_Investment": {
      "sum": true,
      "header": "MDAI I Commitment Co-Investment",
      "column": "MDAI_I_Commitment_Co_Investment",
      "rules": null,
      "dataType": "currency",
      "meta": null,
      "placeholder": null,
      "validations": [],
      "type": "commitment"
    },
    "NY_Balanced_Commitment": {
      "sum": true,
      "header": "NY Balanced Commitment",
      "column": "NY_Balanced_Commitment",
      "rules": null,
      "dataType": "currency",
      "meta": null,
      "placeholder": null,
      "validations": [],
      "type": "commitment"
    },
    "NY_Co_Invst_Commitment": {
      "sum": true,
      "header": "NY Co-Invst Commitment",
      "column": "NY_Co_Invst_Commitment",
      "rules": null,
      "dataType": "currency",
      "meta": null,
      "placeholder": null,
      "validations": [],
      "type": "commitment"
    },
    "Focus_Commitment": {
      "sum": true,
      "header": "Focus Commitment",
      "column": "Focus_Commitment",
      "rules": null,
      "dataType": "currency",
      "meta": null,
      "placeholder": null,
      "validations": [],
      "type": "commitment"
    },
    "Fei_II_Commitment": {
      "sum": true,
      "header": "Fei II Commitment",
      "column": "Fei_II_Commitment",
      "rules": null,
      "dataType": "currency",
      "meta": null,
      "placeholder": null,
      "validations": [],
      "type": "commitment"
    },
    "AACP_IV_Commitment": {
      "sum": true,
      "header": "AACP IV Commitment",
      "column": "AACP_IV_Commitment",
      "rules": null,
      "dataType": "currency",
      "meta": null,
      "placeholder": null,
      "validations": [],
      "type": "commitment"
    },
    "Fund_IV_Side_Car_Commitment": {
      "sum": true,
      "header": "Fund IV Side Car Commitment",
      "column": "Fund_IV_Side_Car_Commitment",
      "rules": null,
      "dataType": "currency",
      "meta": null,
      "placeholder": null,
      "validations": [],
      "type": "commitment"
    },
    "AACP_IV_Ex_Japan_Commitment": {
      "sum": true,
      "header": "AACP IV Ex-Japan Commitment",
      "column": "AACP_IV_Ex_Japan_Commitment",
      "rules": null,
      "dataType": "currency",
      "meta": null,
      "placeholder": null,
      "validations": [],
      "type": "commitment"
    },
    "China_Only_Commitments": {
      "sum": true,
      "header": "China Only Commitments",
      "column": "China_Only_Commitments",
      "rules": null,
      "dataType": "currency",
      "meta": null,
      "placeholder": null,
      "validations": [],
      "type": "commitment"
    },
    "FL_Investors_Commitments_Balanced": {
      "sum": true,
      "header": "FL Investors Commitments Balanced",
      "column": "FL_Investors_Commitments_Balanced",
      "rules": null,
      "dataType": "currency",
      "meta": null,
      "placeholder": null,
      "validations": [],
      "type": "commitment"
    },
    "FL_Investors_Commitments_Co_Investment": {
      "sum": true,
      "header": "FL Investors Commitments Co-Investment",
      "column": "FL_Investors_Commitments_Co_Investment",
      "rules": null,
      "dataType": "currency",
      "meta": null,
      "placeholder": null,
      "validations": [],
      "type": "commitment"
    },
    "MDAI_II_Commitments_Balanced": {
      "sum": true,
      "header": "MDAI II Commitments Balanced",
      "column": "MDAI_II_Commitments_Balanced",
      "rules": null,
      "dataType": "currency",
      "meta": null,
      "placeholder": null,
      "validations": [],
      "type": "commitment"
    },
    "MDAI_II_Commitments_Co_Investment": {
      "sum": true,
      "header": "MDAI II Commitments Co-Investment",
      "column": "MDAI_II_Commitments_Co_Investment",
      "rules": null,
      "dataType": "currency",
      "meta": null,
      "placeholder": null,
      "validations": [],
      "type": "commitment"
    },
    "VA_Investors_Commitments_Balanced": {
      "sum": true,
      "header": "VA Investors Commitments Balanced",
      "column": "VA_Investors_Commitments_Balanced",
      "rules": null,
      "dataType": "currency",
      "meta": null,
      "placeholder": null,
      "validations": [],
      "type": "commitment"
    },
    "VA_Investors_Commitments_Co_Investment": {
      "sum": true,
      "header": "VA Investors Commitments Co-Investment",
      "column": "VA_Investors_Commitments_Co_Investment",
      "rules": null,
      "dataType": "currency",
      "meta": null,
      "placeholder": null,
      "validations": [],
      "type": "commitment"
    },
    "IL_Investors_Commitments_Balanced01": {
      "sum": true,
      "header": "IL Investors Commitments Balanced01",
      "column": "IL_Investors_Commitments_Balanced01",
      "rules": null,
      "dataType": "currency",
      "meta": null,
      "placeholder": null,
      "validations": [],
      "type": "commitment"
    },
    "IL_Investors_Commitments_Balanced02": {
      "sum": true,
      "header": "IL Investors Commitments Balanced02",
      "column": "IL_Investors_Commitments_Balanced02",
      "rules": null,
      "dataType": "currency",
      "meta": null,
      "placeholder": null,
      "validations": [],
      "type": "commitment"
    },
    "IL_Investors_Commitments_Co_Investment": {
      "sum": true,
      "header": "IL Investors Commitments Co-Investment",
      "column": "IL_Investors_Commitments_Co_Investment",
      "rules": null,
      "dataType": "currency",
      "meta": null,
      "placeholder": null,
      "validations": [],
      "type": "commitment"
    },
    "NY_II_Balanced_Commitment": {
      "sum": true,
      "header": "NY II Balanced Commitment",
      "column": "NY_II_Balanced_Commitment",
      "rules": null,
      "dataType": "currency",
      "meta": null,
      "placeholder": null,
      "validations": [],
      "type": "commitment"
    },
    "NY_II_Co_Invst_Commitment": {
      "sum": true,
      "header": "NY II Co-Invst Commitment",
      "column": "NY_II_Co_Invst_Commitment",
      "rules": null,
      "dataType": "currency",
      "meta": null,
      "placeholder": null,
      "validations": [],
      "type": "commitment"
    },
    "Focus_2014_Commitment": {
      "sum": true,
      "header": "Focus 2014 Commitment",
      "column": "Focus_2014_Commitment",
      "rules": null,
      "dataType": "currency",
      "meta": null,
      "placeholder": null,
      "validations": [],
      "type": "commitment"
    },
    "Ivory_III_Commitments_Balanced_AB": {
      "sum": true,
      "header": "Ivory III Commitments Balanced AB",
      "column": "Ivory_III_Commitments_Balanced_AB",
      "rules": null,
      "dataType": "currency",
      "meta": null,
      "placeholder": null,
      "validations": [],
      "type": "commitment"
    },
    "Ivory_III_Commitments_Balanced_C": {
      "sum": true,
      "header": "Ivory III Commitments Balanced C",
      "column": "Ivory_III_Commitments_Balanced_C",
      "rules": null,
      "dataType": "currency",
      "meta": null,
      "placeholder": null,
      "validations": [],
      "type": "commitment"
    },
    "Ivory_III_Commitments_o_Investment": {
      "sum": true,
      "header": "Ivory III Commitments o-Investment",
      "column": "Ivory_III_Commitments_o_Investment",
      "rules": null,
      "dataType": "currency",
      "meta": null,
      "placeholder": null,
      "validations": [],
      "type": "commitment"
    },
    "NJAI_III_Commitments_Balanced": {
      "sum": true,
      "header": "NJAI III Commitments Balanced",
      "column": "NJAI_III_Commitments_Balanced",
      "rules": null,
      "dataType": "currency",
      "meta": null,
      "placeholder": null,
      "validations": [],
      "type": "commitment"
    },
    "NJAI_III_Commitments_Co_Investment": {
      "sum": true,
      "header": "NJAI III Commitments Co-Investment",
      "column": "NJAI_III_Commitments_Co_Investment",
      "rules": null,
      "dataType": "currency",
      "meta": null,
      "placeholder": null,
      "validations": [],
      "type": "commitment"
    },
    "Fei_III": {
      "sum": true,
      "header": "Fei III",
      "column": "Fei_III",
      "rules": null,
      "dataType": "currency",
      "meta": null,
      "placeholder": null,
      "validations": [],
      "type": null
    },
    "Hessen_Dr_Commitments_Balanced_I": {
      "sum": true,
      "header": "Hessen Dr# Commitments Balanced I",
      "column": "Hessen_Dr_Commitments_Balanced_I",
      "rules": null,
      "dataType": "currency",
      "meta": null,
      "placeholder": null,
      "validations": [],
      "type": "commitment"
    },
    "Hessen_Dr_Commitments_Balanced_II": {
      "sum": true,
      "header": "Hessen Dr# Commitments Balanced II",
      "column": "Hessen_Dr_Commitments_Balanced_II",
      "rules": null,
      "dataType": "currency",
      "meta": null,
      "placeholder": null,
      "validations": [],
      "type": "commitment"
    },
    "Hessen_Dr_Commitments_Co_Investment": {
      "sum": true,
      "header": "Hessen Dr# Commitments Co-Investment",
      "column": "Hessen_Dr_Commitments_Co_Investment",
      "rules": null,
      "dataType": "currency",
      "meta": null,
      "placeholder": null,
      "validations": [],
      "type": "commitment"
    },
    "Arcadia_Asia_Investors_LP_Commitments_Balanced": {
      "sum": true,
      "header": "Arcadia Asia Investors, LP Commitments Balanced",
      "column": "Arcadia_Asia_Investors_LP_Commitments_Balanced",
      "rules": null,
      "dataType": "currency",
      "meta": null,
      "placeholder": null,
      "validations": [],
      "type": "commitment"
    },
    "Arcadia_Asia_Investors_LP_Commitments_Co_Investment": {
      "sum": true,
      "header": "Arcadia Asia Investors, LP Commitments Co-Investment",
      "column": "Arcadia_Asia_Investors_LP_Commitments_Co_Investment",
      "rules": null,
      "dataType": "currency",
      "meta": null,
      "placeholder": null,
      "validations": [],
      "type": "commitment"
    },
    "AACP_V_Commitment": {
      "sum": true,
      "header": "AACP V Commitment",
      "column": "AACP_V_Commitment",
      "rules": null,
      "dataType": "currency",
      "meta": null,
      "placeholder": null,
      "validations": [],
      "type": "commitment"
    },
    "AACP_V_ERISA_Commitment": {
      "sum": true,
      "header": "AACP V (ERISA) Commitment",
      "column": "AACP_V_ERISA_Commitment",
      "rules": null,
      "dataType": "currency",
      "meta": null,
      "placeholder": null,
      "validations": [],
      "type": "commitment"
    },
    "AACP_V_Side_Car_Commitment": {
      "sum": true,
      "header": "AACP V Side Car Commitment",
      "column": "AACP_V_Side_Car_Commitment",
      "rules": null,
      "dataType": "currency",
      "meta": null,
      "placeholder": null,
      "validations": [],
      "type": "commitment"
    },
    "FL_Investors_II_Commitments_Balanced": {
      "sum": true,
      "header": "FL Investors II Commitments Balanced",
      "column": "FL_Investors_II_Commitments_Balanced",
      "rules": null,
      "dataType": "currency",
      "meta": null,
      "placeholder": null,
      "validations": [],
      "type": "commitment"
    },
    "FL_Investors_II_Commitments_Co_Investment": {
      "sum": true,
      "header": "FL Investors II Commitments Co-Investment",
      "column": "FL_Investors_II_Commitments_Co_Investment",
      "rules": null,
      "dataType": "currency",
      "meta": null,
      "placeholder": null,
      "validations": [],
      "type": "commitment"
    },
    "MDAI_III_Commitments_Balanced": {
      "sum": true,
      "header": "MDAI III Commitments Balanced",
      "column": "MDAI_III_Commitments_Balanced",
      "rules": null,
      "dataType": "currency",
      "meta": null,
      "placeholder": null,
      "validations": [],
      "type": "commitment"
    },
    "MDAI_III_Commitments_Co_Investment": {
      "sum": true,
      "header": "MDAI III Commitments Co-Investment",
      "column": "MDAI_III_Commitments_Co_Investment",
      "rules": null,
      "dataType": "currency",
      "meta": null,
      "placeholder": null,
      "validations": [],
      "type": "commitment"
    },
    "VA_Investors_II_Commitments_Balanced": {
      "sum": true,
      "header": "VA Investors II Commitments Balanced",
      "column": "VA_Investors_II_Commitments_Balanced",
      "rules": null,
      "dataType": "currency",
      "meta": null,
      "placeholder": null,
      "validations": [],
      "type": "commitment"
    },
    "VA_Investors_II_Commitments_Co_Investment": {
      "sum": true,
      "header": "VA Investors II Commitments Co-Investment",
      "column": "VA_Investors_II_Commitments_Co_Investment",
      "rules": null,
      "dataType": "currency",
      "meta": null,
      "placeholder": null,
      "validations": [],
      "type": "commitment"
    },
    "NY_III_Balanced_Commitment": {
      "sum": true,
      "header": "NY III Balanced Commitment",
      "column": "NY_III_Balanced_Commitment",
      "rules": null,
      "dataType": "currency",
      "meta": null,
      "placeholder": null,
      "validations": [],
      "type": "commitment"
    },
    "NY_III_Co_Invst_Commitment": {
      "sum": true,
      "header": "NY III Co-Invst Commitment",
      "column": "NY_III_Co_Invst_Commitment",
      "rules": null,
      "dataType": "currency",
      "meta": null,
      "placeholder": null,
      "validations": [],
      "type": "commitment"
    },
    "FL_Investors_III_Commitments_Balanced": {
      "sum": true,
      "header": "FL Investors III Commitments Balanced",
      "column": "FL_Investors_III_Commitments_Balanced",
      "rules": null,
      "dataType": "currency",
      "meta": null,
      "placeholder": null,
      "validations": [],
      "type": "commitment"
    },
    "FL_Investors_III_Commitments_Co_Investment": {
      "sum": true,
      "header": "FL Investors III Commitments Co-Investment",
      "column": "FL_Investors_III_Commitments_Co_Investment",
      "rules": null,
      "dataType": "currency",
      "meta": null,
      "placeholder": null,
      "validations": [],
      "type": "commitment"
    },
    "Ivory_IV_Commitments_Balanced_A": {
      "sum": true,
      "header": "Ivory IV Commitments Balanced A",
      "column": "Ivory_IV_Commitments_Balanced_A",
      "rules": null,
      "dataType": "currency",
      "meta": null,
      "placeholder": null,
      "validations": [],
      "type": "commitment"
    },
    "Ivory_IV_Commitments_Balanced_B": {
      "sum": true,
      "header": "Ivory IV Commitments Balanced B",
      "column": "Ivory_IV_Commitments_Balanced_B",
      "rules": null,
      "dataType": "currency",
      "meta": null,
      "placeholder": null,
      "validations": [],
      "type": "commitment"
    },
    "Ivory_IV_Commitments_Co_Investment": {
      "sum": true,
      "header": "Ivory IV Commitments Co-Investment",
      "column": "Ivory_IV_Commitments_Co_Investment",
      "rules": null,
      "dataType": "currency",
      "meta": null,
      "placeholder": null,
      "validations": [],
      "type": "commitment"
    },
    "MDAI_IV_Commitments_Balanced": {
      "sum": true,
      "header": "MDAI IV Commitments Balanced",
      "column": "MDAI_IV_Commitments_Balanced",
      "rules": null,
      "dataType": "currency",
      "meta": null,
      "placeholder": null,
      "validations": [],
      "type": "commitment"
    },
    "MDAI_IV_Commitments_Co_Investment": {
      "sum": true,
      "header": "MDAI IV Commitments Co-Investment",
      "column": "MDAI_IV_Commitments_Co_Investment",
      "rules": null,
      "dataType": "currency",
      "meta": null,
      "placeholder": null,
      "validations": [],
      "type": "commitment"
    },
    "VA_Investors_III_Commitments_Balanced": {
      "sum": true,
      "header": "VA Investors III Commitments Balanced",
      "column": "VA_Investors_III_Commitments_Balanced",
      "rules": null,
      "dataType": "currency",
      "meta": null,
      "placeholder": null,
      "validations": [],
      "type": "commitment"
    },
    "VA_Investors_III_Commitments_Co_Investment": {
      "sum": true,
      "header": "VA Investors III Commitments Co-Investment",
      "column": "VA_Investors_III_Commitments_Co_Investment",
      "rules": null,
      "dataType": "currency",
      "meta": null,
      "placeholder": null,
      "validations": [],
      "type": "commitment"
    },
    "MN_Asia_Investors_Commitments_Balanced": {
      "sum": true,
      "header": "MN Asia Investors Commitments Balanced",
      "column": "MN_Asia_Investors_Commitments_Balanced",
      "rules": null,
      "dataType": "currency",
      "meta": null,
      "placeholder": null,
      "validations": [],
      "type": "commitment"
    },
    "MN_Asia_Investors_Commitments_Co_Investment": {
      "sum": true,
      "header": "MN Asia Investors Commitments Co-Investment",
      "column": "MN_Asia_Investors_Commitments_Co_Investment",
      "rules": null,
      "dataType": "currency",
      "meta": null,
      "placeholder": null,
      "validations": [],
      "type": "commitment"
    },
    "AACP_VI_Commitment": {
      "sum": true,
      "header": "AACP VI Commitment",
      "column": "AACP_VI_Commitment",
      "rules": null,
      "dataType": "currency",
      "meta": null,
      "placeholder": null,
      "validations": [],
      "type": "commitment"
    },
    "AACP_VI_ERISA_Commitment": {
      "sum": true,
      "header": "AACP VI (ERISA) Commitment",
      "column": "AACP_VI_ERISA_Commitment",
      "rules": null,
      "dataType": "currency",
      "meta": null,
      "placeholder": null,
      "validations": [],
      "type": "commitment"
    },
    "AACP_VI_Europe_Commitment": {
      "sum": true,
      "header": "AACP VI Europe Commitment",
      "column": "AACP_VI_Europe_Commitment",
      "rules": null,
      "dataType": "currency",
      "meta": null,
      "placeholder": null,
      "validations": [],
      "type": "commitment"
    },
    "Fund_VI_Side_Cars": {
      "sum": true,
      "header": "Fund VI Side Cars",
      "column": "Fund_VI_Side_Cars",
      "rules": null,
      "dataType": "currency",
      "meta": null,
      "placeholder": null,
      "validations": [],
      "type": null
    },
    "Penn_Asia_Commitment": {
      "sum": true,
      "header": "Penn Asia Commitment",
      "column": "Penn_Asia_Commitment",
      "rules": null,
      "dataType": "currency",
      "meta": null,
      "placeholder": null,
      "validations": [],
      "type": "commitment"
    },
    "SBS_Asia_I_Commitment": {
      "sum": true,
      "header": "SBS Asia I Commitment",
      "column": "SBS_Asia_I_Commitment",
      "rules": null,
      "dataType": "currency",
      "meta": null,
      "placeholder": null,
      "validations": [],
      "type": "commitment"
    },
    "NG_Asia_Commitment": {
      "sum": true,
      "header": "NG Asia Commitment",
      "column": "NG_Asia_Commitment",
      "rules": null,
      "dataType": "currency",
      "meta": null,
      "placeholder": null,
      "validations": [],
      "type": "commitment"
    },
    "NM_Asia_Commitment": {
      "sum": true,
      "header": "NM Asia Commitment",
      "column": "NM_Asia_Commitment",
      "rules": null,
      "dataType": "currency",
      "meta": null,
      "placeholder": null,
      "validations": [],
      "type": "commitment"
    },
    "SF_Asia_Commitment": {
      "sum": true,
      "header": "SF Asia Commitment",
      "column": "SF_Asia_Commitment",
      "rules": null,
      "dataType": "currency",
      "meta": null,
      "placeholder": null,
      "validations": [],
      "type": "commitment"
    },
    "Fei_Co_Investment": {
      "sum": true,
      "header": "Fei Co-Investment",
      "column": "Fei_Co_Investment",
      "rules": null,
      "dataType": "currency",
      "meta": null,
      "placeholder": null,
      "validations": [],
      "type": "commitment"
    },
    "MassMutual_Co_Investment": {
      "sum": true,
      "header": "MassMutual Co-Investment",
      "column": "MassMutual_Co_Investment",
      "rules": null,
      "dataType": "currency",
      "meta": null,
      "placeholder": null,
      "validations": [],
      "type": "commitment"
    },
    "Calculated_Commitment": {
      "header": "Calculated_Commitment",
      "column": "Calculated_Commitment",
      "rules": null,
      "dataType": "currency",
      "meta": null,
      "placeholder": null,
      "validations": [],
      "type": null
    },
    "Discrepancy": {
      "header": "Discrepancy",
      "column": "Discrepancy",
      "rules": null,
      "dataType": "currency",
      "meta": null,
      "placeholder": null,
      "validations": [],
      "type": null
    },
    "Total__Commitment": {
      "header": "Total  Commitment",
      "column": "Total__Commitment",
      "rules": null,
      "dataType": "currency",
      "meta": null,
      "placeholder": null,
      "validations": [],
      "type": null
    },
    "Geography": {
      "header": "Geography",
      "column": "Geography",
      "rules": null,
      "dataType": "currency",
      "meta": null,
      "placeholder": null,
      "validations": [],
      "type": null
    },
    "Sub_Asset_Class": {
      "header": "Sub Asset Class",
      "column": "Sub_Asset_Class",
      "rules": null,
      "dataType": "currency",
      "meta": null,
      "placeholder": null,
      "validations": [],
      "type": null
    },
    "Defined_Manager_Type": {
      "header": "Defined Manager Type",
      "column": "Defined_Manager_Type",
      "rules": null,
      "dataType": "currency",
      "meta": null,
      "placeholder": null,
      "validations": [],
      "type": null
    },
    "Defined_Strategy": {
      "header": "Defined Strategy",
      "column": "Defined_Strategy",
      "rules": null,
      "dataType": "currency",
      "meta": null,
      "placeholder": null,
      "validations": [],
      "type": null
    },
    "Fund_Size": {
      "header": "Fund Size",
      "column": "Fund_Size",
      "rules": null,
      "dataType": "currency",
      "meta": null,
      "placeholder": null,
      "validations": [],
      "type": null
    },
    "Fund_Size_Category": {
      "header": "Fund Size Category",
      "column": "Fund_Size_Category",
      "rules": null,
      "dataType": "currency",
      "meta": null,
      "placeholder": null,
      "validations": [],
      "type": null
    },
    "Vintage_Year": {
      "header": "Vintage Year",
      "column": "Vintage_Year",
      "rules": null,
      "dataType": "date",
      "meta": null,
      "placeholder": null,
      "validations": [],
      "type": null
    },
    "Advisory_Board": {
      "header": "Advisory Board",
      "column": "Advisory_Board",
      "rules": null,
      "dataType": "currency",
      "meta": null,
      "hidden": true,
      "placeholder": null,
      "validations": [],
      "type": null
    },
    "Who_AB": {
      "header": "Who AB",
      "column": "Who_AB",
      "rules": null,
      "dataType": "currency",
      "hidden": true,
      "meta": null,
      "placeholder": null,
      "validations": [],
      "type": null
    },
    "Deal_Sourcer": {
      "header": "Deal Sourcer",
      "column": "Deal_Sourcer",
      "rules": null,
      "hidden": true,
      "dataType": "currency",
      "meta": null,
      "placeholder": null,
      "validations": [],
      "type": null
    },
    "Team_Lead": {
      "header": "Team Lead",
      "column": "Team_Lead",
      "rules": null,
      "dataType": "currency",
      "meta": null,
      "placeholder": null,
      "validations": [],
      "type": null
    },
    "Current_Team": {
      "header": "Current Team",
      "column": "Current_Team",
      "rules": null,
      "dataType": "currency",
      "meta": null,
      "placeholder": null,
      "validations": [],
      "type": null
    },
    "Oversubscribed": {
      "header": "Oversubscribed",
      "column": "Oversubscribed",
      "rules": null,
      "dataType": "currency",
      "meta": null,
      "placeholder": null,
      "validations": [],
      "type": null
    },
    "Co_investment_Offered": {
      "header": "Co-investment Offered",
      "column": "Co_investment_Offered",
      "rules": null,
      "dataType": "currency",
      "meta": null,
      "placeholder": null,
      "validations": [],
      "type": null
    },
    "Investment_Period_End_Date": {
      "header": "Investment Period End Date",
      "column": "Investment_Period_End_Date",
      "rules": null,
      "dataType": "date",
      "meta": null,
      "placeholder": null,
      "validations": [],
      "type": null
    },
    "China": {
      "header": "China",
      "column": "China",
      "rules": null,
      "hidden": true,
      "dataType": "currency",
      "meta": null,
      "placeholder": null,
      "validations": [],
      "type": null
    },
    "Japan": {
      "header": "Japan",
      "column": "Japan",
      "rules": null,
      "hidden": true,
      "dataType": "currency",
      "meta": null,
      "placeholder": null,
      "validations": [],
      "type": null
    },
    "Korea": {
      "header": "Korea",
      "column": "Korea",
      "rules": null,
      "hidden": true,
      "dataType": "currency",
      "meta": null,
      "placeholder": null,
      "validations": [],
      "type": null
    },
    "India": {
      "header": "India",
      "column": "India",
      "rules": null,
      "dataType": "currency",
      "hidden": true,
      "meta": null,
      "placeholder": null,
      "validations": [],
      "type": null
    },
    "Pan_Asia": {
      "header": "Pan Asia",
      "column": "Pan_Asia",
      "rules": null,
      "dataType": "currency",
      "hidden": true,
      "meta": null,
      "placeholder": null,
      "validations": [],
      "type": null
    },
    "Australia": {
      "header": "Australia",
      "column": "Australia",
      "rules": null,
      "dataType": "currency",
      "hidden": true,
      "meta": null,
      "placeholder": null,
      "validations": [],
      "type": null
    },
    "Indonesia": {
      "header": "Indonesia",
      "column": "Indonesia",
      "rules": null,
      "dataType": "currency",
      "hidden": true,
      "meta": null,
      "placeholder": null,
      "validations": [],
      "type": null
    },
    "Primary": {
      "header": "Primary",
      "column": "Primary",
      "rules": null,
      "dataType": "currency",
      "meta": null,
      "placeholder": null,
      "validations": [],
      "type": null
    },
    "Secondary": {
      "header": "Secondary",
      "column": "Secondary",
      "rules": null,
      "dataType": "currency",
      "meta": null,
      "placeholder": null,
      "validations": [],
      "type": null
    },
    "Direct_Co_Investment": {
      "header": "Direct Co-Investment",
      "column": "Direct_Co_Investment",
      "rules": null,
      "dataType": "currency",
      "meta": null,
      "placeholder": null,
      "validations": [],
      "type": null
    },
    "Structured_Primary": {
      "header": "Structured Primary",
      "column": "Structured_Primary",
      "rules": null,
      "dataType": "currency",
      "hidden": true,
      "meta": null,
      "placeholder": null,
      "validations": [],
      "type": null
    },
    "Y2005_Earlier": {
      "header": "2005 Earlier",
      "column": "Y2005_Earlier",
      "rules": null,
      "dataType": "currency",
      "hidden": true,
      "meta": null,
      "placeholder": null,
      "validations": [],
      "type": null
    }
  }
}
export { commitment }

